module.exports = __webpack_public_path__ + "static/media/016.3abf5b4c.png";